import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ConfDialogType, ConfirmDialogModel } from "./confim-dialog.model";

@Component({
    selector: "app-confirm-dialog",
    templateUrl: "./confirm-dialog.component.html",
    styleUrls: ["./confirm-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);
  data = inject<ConfirmDialogModel>(MAT_DIALOG_DATA);

  title: string;
  message: string;
  DialogType = ConfDialogType;

  constructor() {
    const data = this.data;

    // Update view with given values
    this.title = data.title;
    this.message = data.message;
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
